export enum DownloadType {
  AVATAR = 'AVATAR',
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
  REEL = 'REEL',
}
